import PropTypes from "prop-types";

const FormInput = ({
  errorMessage,
  labelText,
  type,
  placeholder,
  value,
  onChange,
  id,
  name,
  defaultValue,
  htmlFor,
  isFieldRequired,
  children,
  maxLength,
  disabled
}) => {
  return (
    <div className="form-group">
      <div className="label-wrapper">
        <label htmlFor={htmlFor} className="label">
          {isFieldRequired ? `${labelText}*` : labelText}
        </label>
        {errorMessage && <div className="error-msg">{errorMessage}</div>}
      </div>
      {!children ? (
        <input
          className="input-field"
          type={type}
          placeholder={placeholder}
          value={value || ""}
          onChange={onChange}
          id={id}
          name={name}
          defaultValue={defaultValue}
          maxLength={maxLength}
          disabled={disabled}
        />
      ) : (
        children
      )}
    </div>
  );
};

export default FormInput;

FormInput.propTypes = {
  errorMessage: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  isFieldRequired: PropTypes.bool.isRequired,
  children: PropTypes.node,
  defaultValue: PropTypes.string,
  htmlFor: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool
};
